import { NgwMap } from '@nextgis/ngw-map';
import {
  Module,
  MutationAction,
  VuexModule,
  getModule,
} from 'vuex-module-decorators';

import store from '../index';

type WebMapState = {
  debug?: boolean;
  activePopupTab?: string | null;
  ngwMapId?: number | null;
};

@Module({ dynamic: true, store, name: 'webMap' })
export class WebMap extends VuexModule {
  ngwMapId: number | null = null;
  debug = false;
  activePopupTab: string | null = null;

  get ngwMap(): NgwMap | null {
    const ngwMap = NgwMap.get<NgwMap>(this.ngwMapId as number);
    return ngwMap ? ngwMap : null;
  }

  @MutationAction<WebMapState>({ mutate: ['ngwMapId'] })
  async setMap(ngwMap: NgwMap | null): Promise<WebMapState> {
    const ngwMapId = ngwMap ? ngwMap.getId() : null;
    return { ngwMapId };
  }

  @MutationAction<WebMapState>({ mutate: ['activePopupTab'] })
  async setActivePopupTab(activePopupTab: string | null): Promise<WebMapState> {
    return { activePopupTab };
  }

  @MutationAction<WebMapState>({ mutate: ['debug'] })
  async setDebug(debug: boolean): Promise<WebMapState> {
    return { debug };
  }
}

export const webMapModule = getModule(WebMap);
